import { useState } from "react";
import { Link } from "react-router-dom";
import "./nav.css";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="nav">
      <div className="nav-container">

        {/* Left: Logo */}
        <div className="nav-logo">
          <Link to="/">
            <img src="/assets/logos/light-png.png" alt="Logo" />
          </Link>
        </div>


        {/* Center: Desktop Menu */}
        <ul className="nav-links desktop-menu">
          <li><Link to="/">Home</Link></li>
          <li><Link to="/about">About</Link></li>
          <li><Link to="/menu">Menu</Link></li>
          <li><Link to="/contact">Contact</Link></li>
          <li><Link to="/career">Careers</Link></li>
          {/* <li><Link to="/profile">Profile</Link></li> */}
        </ul>

        {/* Right: Social Icons */}
        <div className="nav-social desktop-social">
          <a href="https://www.facebook.com/share/1FdxVBaEiF/"><i className="fab fa-facebook-f"></i></a>
          <a href="https://www.instagram.com/noshandnector?igsh=YTFkanVnYXBqYTdh"><i className="fab fa-instagram"></i></a>
          <a href="#"><i class="fab fa-tiktok"></i></a>
          <a href="#"><i className="fab fa-youtube"></i></a>

        </div>

        {/* Hamburger Icon */}
        <div className="nav-toggle" onClick={() => setOpen(!open)}>
          <div className={open ? "bar rotate1" : "bar"}></div>
          <div className={open ? "bar hide" : "bar"}></div>
          <div className={open ? "bar rotate2" : "bar"}></div>
        </div>

      </div>

      {/* MOBILE MENU */}
      <div className={open ? "mobile-menu open" : "mobile-menu"}>
        <ul className="mobile-links">
          <li><Link to="/" onClick={() => setOpen(false)}>Home</Link></li>
          <li><Link to="/about" onClick={() => setOpen(false)}>About</Link></li>
          <li><Link to="/menu" onClick={() => setOpen(false)}>Menu</Link></li>
          <li><Link to="/contact" onClick={() => setOpen(false)}>Contact</Link></li>
          <li><Link to="/career" onClick={() => setOpen(false)}>Careers</Link></li>

          {/* <li><Link to="/profile" onClick={() => setOpen(false)}>Profile</Link></li> */}
        </ul>

        {/* Social Media at Bottom */}
        <div className="mobile-social">
          <a href="https://www.facebook.com/share/1FdxVBaEiF/"><i className="fab fa-facebook-f"></i></a>
          <a href="https://www.instagram.com/noshandnector?igsh=YTFkanVnYXBqYTdh"><i className="fab fa-instagram"></i></a>
          <a href="https://www.tiktok.com/@nosh.and.nector?_r=1&_t=ZS-93hRnpia5f5"> <i className="fab fa-tiktok">  </i></a>
          <a href="https://youtube.com/@noshandnector-r5j?si=uJaJh5E3hVSRR8H6"> <i className="fab fa-youtube"> </i></a>
        </div>
      </div>

    </nav>
  );
}
